<div
  [class.timesheet-grid]="last"
  [ngClass]="{ italic: !!teamId && !employee.Team.includes(teamId) }"
  class="timesheet-user-block pl-3"
  [ngStyle]="{ 'height.px': height }"
>
  @if (show) {
    <div class="avatar-item">
      <div class="mr-2.5 flex items-center">
        <sb-legacy-avatar [employee]="employee" [size]="30"></sb-legacy-avatar>
      </div>
      <div class="avatar-item__details" [style.width.px]="160">
        <div class="truncate text-base font-semibold">
          <a
            [ngClass]="{ 'pointer-events-none': !canViewEmployee }"
            [routerLink]="['/employees', employee.id, 'timesheet']"
            [sbTooltip]="'Loaned' | translate"
            [sbTooltipDisabled]="!teamId || employee.Team.includes(teamId)"
            data-hj-suppress
          >
            {{ employee.name }}
          </a>
        </div>
        <div class="timesheet-totals">
          <div class="timesheet-totals__time" [sbTooltipPlacement]="'top'" [sbTooltip]="'Approved hours' | translate">
            <small data-testid="timesheet-employee-total-time">{{
              approvedTotal.hours | localeDuration: 'digital'
            }}</small>
          </div>
          @if (showSalary) {
            <div
              class="timesheet-totals__salary"
              [sbTooltipPlacement]="'top'"
              [sbTooltip]="'Worked - Scheduled' | translate"
            >
              @if (scheduleDiff !== 0) {
                <small data-testid="timesheet-employee-schedule-diff"
                  ><span>{{ scheduleDiff | localeDuration: 'digital' }}</span></small
                >
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
